/* eslint-disable @typescript-eslint/naming-convention */
export namespace SecurityUtils {
    /**
     * Sanitizes a string by replacing special characters with their corresponding HTML entities.
     *
     * @param {string} text - The string to be sanitized.
     * @return {string} The sanitized string.
     */
    export const sanitize = (text: string) => {
        const map = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "/": "&#x2F;",
        };
        const reg = /[&<>"'/]/gi;
        return text.replace(reg, (match) => map[match]);
    };
}
